// extracted by mini-css-extract-plugin
export default {"error":"Error_error__QUyVW","logo":"Error_logo__sd228","talk":"Error_talk__DG6-K","robot":"Error_robot__dihih","circle":"Error_circle__UI1-v"};